<template>
  <div class="comming">
    <div class="first-loading-wrp">
      <div class="loading-wrp">
        <span class="img-wrap">
          <img
            class="spin"
            src="data:image/png;base64,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"
          />
        </span>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 54px;
        "
      >
        正在进入会议
      </div>
    </div>
    <a-modal
      v-model="browserVisiable"
      :maskClosable="false"
      title="浏览器下载"
      :width="500"
      centered
      @cancel="toLogin"
      :footer="null"
    >
      <div class="info-container">
        <div class="mt-itme"></div>
        <div class="mt-item">
          推荐使用Google Chrome、Microsoft Edge Chromium浏览器入会。
        </div>
        <div class="mt-item">
          <a
            class="links"
            href="https://www.google.cn/intl/zh-CN/chrome/"
            target="_blank"
            >下载 Google Chrome 浏览器</a
          >
        </div>
        <div class="mt-item">
          <a
            class="links"
            href="https://www.microsoft.com/zh-cn/edge"
            target="_blank"
            >下载 Microsoft Edge Chromium 浏览器</a
          >
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { browserInfo } from "@/utils/util";
export default {
  name: "Hst",
  data() {
    return {
      roomId: this.$route.query.roomId, // 会议室号
      userName: this.$route.query.userName, // 用户名
      browser: browserInfo(),
      browserVisiable: false, // 浏览器弹窗
    };
  },
  created() {
    if (
      /(chrome|Edg)/.test(this.browser.name) &&
      this.browser.version.split(".")[0] >= 88
    ) {
      this.toLogin();
    } else {
      this.browserVisiable = true;
    }
  },
  methods: {
    toLogin() {
      const { roomId, userName } = this;
      if (
        ![undefined, ""].includes(roomId) &&
        ![undefined, ""].includes(userName)
      ) {
        // 登录成功跳转会议页面
        this.$router.replace({
          path: "/meeting",
          query: { ...this.$route.query },
        });
      } else {
        this.$router.replace("/login");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.comming {
  height: 100%;
}
.first-loading-wrp {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background: url("~@/assets/img/bg2_img.png") no-repeat no-repeat;
  background-size: cover;
  color: #42424a;
}
.first-loading-wrp .loading-wrp {
  /* padding:98px;*/
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-wrap {
  animation: antRotate 1.2s infinite linear;
  position: relative;
  display: inline-block;
  font-size: 36px;
  box-sizing: border-box;
}
.spin {
  display: block;
  width: 36px;
  height: 36px;
}
@keyframes antRotate {
  to {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg);
  }
}
@-webkit-keyframes antRotate {
  to {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg);
  }
}

.info-container {
  padding: 40px 50px 50px 60px;
  .mt-title {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999ea3;
    line-height: 30px;
  }
  .links {
    text-decoration: underline;
    color: #5aa4f7;
  }
}

.pwd-container {
  padding: 30px 90px 20px;
  .mt-title {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999ea3;
    line-height: 32px;
  }
}
</style>
